import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, actions } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import {
    OR_RRF_TextArea as TextArea
    , OR_RRF_Select as Select
    , OR_RRF_InputField as InputField
    , ORFButton as Button
} from '../../../../../../common/forms/order-request-form.component';
import { newCircuitExhibitBActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-exhibit-b.reducer";
import Translation from '../../../../../../common/translation/translation.component';
import { TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
//import './wireless-location-form.component.css';

class WirelineLocationFormB extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.getNewCircuitFormData();
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {
        const {
            //component props
            nextAction, onClickCancel
            // form
            , wirelineLocationFormB
            // reducer action
            , onCountrySelect
            , onAddressSelect
        } = this.props;

        const { countryOptions } = this.props.newCircuitExhibitBRequest;

        //const requiredValidation = { required: (val) => val && val.length};
        //const countryValidationsErrorMsgs = { required: 'Country field is required.'};
        //const addressValidationsErrorMsgs = { required: 'Address field is required.' };
        //let showPreferredAddress = wirelineLocationFormB.locationId === "0";
        let disable = wirelineLocationFormB.countryCode == ''
            || wirelineLocationFormB.wirelineDeliveryAddress === ''
            || wirelineLocationFormB.companyCode === '';

        //if (showPreferredAddress) {
        //    disable = disable || wirelineLocationFormB.otherDeliveryAddress == '';
        //}

        return (
            <div >
                <Form method="post" role="form"
                    model="wirelineLocationFormB"
                    onSubmit={nextAction}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('country')} *`}
                                value={wirelineLocationFormB.countryCode}
                                options={countryOptions}
                                placeholder={this.toLocaleLanguage('select_a_country')}
                                fieldProp='.countryCode'
                                onChangeAction={onCountrySelect}
                            //validators={requiredValidation}
                            //errorMessages={countryValidationsErrorMsgs}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={`${this.toLocaleLanguage('delivery_address')} *`}
                                fieldProp='.wirelineDeliveryAddress'
                                value={wirelineLocationFormB.wirelineDeliveryAddress}
                                maxLength="255"
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <InputField
                                className="form-control"
                                type="text"
                                label={`${this.toLocaleLanguage('company_code')} *`}
                                value={wirelineLocationFormB.companyCode}
                                fieldProp='.companyCode'
                            />
                        </Col>
                    </Row>
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <Button
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            {
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('next_button')}
                                        type={"submit"}
                                        variant={"primary"}
                                        disabled={disable}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default connect(
    state => {
        const { newCircuitExhibitBRequest, translation } = state;
        const { wirelineLocationFormB } = state.form;
        return {
            newCircuitExhibitBRequest
            , wirelineLocationFormB
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newCircuitExhibitBActions),
            dispatch
        )
)(WirelineLocationFormB);